import {
  SAVE_ABOUT,
  SAVE_ABOUT_SUCCESS,
  SAVE_ABOUT_FAILURE
} from './actionTypes';

const initialState = {
  isSaving: false,
  about: {},
  error: []
};

export const newAboutReducer = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_ABOUT:
      return { ...state, isSaving: true };
    case SAVE_ABOUT_SUCCESS:
      return { ...state, isSaving: false, about: action.payload };
    case SAVE_ABOUT_FAILURE:
      return {
        ...state,
        error: action.payload
      };
    default:
      return state;
  }
};

export const isSaving = state => state.newAbout.isSaving;
export const getAbout = state => state.newAbout.about;
export const getError = state => state.newAbout.error;



// WEBPACK FOOTER //
// ./src/modules/AboutForm/reducer.js